<template>
  <div class="text-left">
    <GoBackButton />
    <div class="bg-card">
      <h2>{{ $t('pages.killer-questions-templates.add-folder.title', 'New folder') }}</h2>
      <p class="subtext">
        {{ $t('pages.killer-questions-templates.add-folder.subtitle') }}
      </p>
      <div class="mb-4">
        <label
          for="folder-name"
          class="mb-0"
        >{{ $t('pages.killer-questions-templates.add-folder.folder-name', 'Folder name:') }}</label>
        <b-form-input
          id="folder-name"
          v-model="$v.folderName.$model"
          :state="$v.folderName.$dirty ? !$v.folderName.$error : null"
          size="sm"
        />
      </div>
      <div
        v-show="rootFolderExists"
        class="mb-4"
      >
        <div>{{ $t('pages.killer-questions-templates.add-folder.save-folder-in', 'Save folder to:') }}</div>
        <b-alert
          variant="danger"
          :show="isSaveFolderSelected"
        >
          <font-awesome-icon
            icon="exclamation-triangle"
            class="danger-icon m-auto"
          />
          {{ $t('pages.killer-questions-templates.add-folder.must-select-folder', 'You must select a folder!') }}
        </b-alert>
        <div>
          <FoldersTree
            :folders-data="killerqFolders"
            :show-questions="false"
            :is-expanded="true"
            :is-folder-select="true"
            :selected-folder="selectedFolder"
            @node-click="selectFolder"
          />
        </div>
      </div>
      <div class="row justify-content-center mb-2">
        <b-button
          variant="success"
          size="sm"
          class="mr-1"
          @click="addFolder()"
        >
          {{ $t('generic.save') }}
        </b-button>
        <b-button
          variant="secondary"
          size="sm"
          @click="$router.go(-1)"
        >
          {{ $t('generic.cancel') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import FoldersTree from '@/components/jobs/killerQuestionsTemplates/FoldersTree';

export default {
  components: {
    GoBackButton,
    FoldersTree
  },
  data() {
    return {
      folderName: "",
      killerqFolders: null,
      selectedFolder: {
        title: ""
      },
      init: true
    }
  },
  validations: {
    folderName: { required }
  },
  computed: {
    isSaveFolderSelected() {
      return !this.init && this.selectedFolder.title === "";
    },
    isAdmin() {
      return this.$hasRole(['admin']);
    },
    rootFolderExists() {
      return this.killerqFolders && this.killerqFolders.length > 0;
    }
  },
  mounted() {
    this.getAll();
  },
  methods: {
    getAll() {
      let url = this.isAdmin ? '/killer-questions-templates/all-admin'
          : '/killer-questions-templates/all-user';

      this.axios.get(url)
        .then( response => {
          this.killerqFolders = response.data;
        });
    },
    selectFolder(node) {
      this.selectedFolder = node;
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toastNotification('danger', '', this.$t('pages.killer-questions-templates.add-folder.failure', 'All fields must be filled!'));
        return false;
      } else {
        return true;
      }
    },
    addFolder() {
      this.init = false;

      let data = {
        folderName: this.folderName,
        parent_id: this.selectedFolder.id
      }

      if(this.selectedFolder.title == "" && this.rootFolderExists) {
        this.$toastNotification('danger', '', this.$t('pages.killer-questions-templates.add-folder.failure', 'All fields must be filled!'));
        return;
      }

      if(this.validate()) {
        let url = this.rootFolderExists ? '/killer-questions-templates/add-folder'
            : '/killer-questions-templates/add-root-folder';
        
        this.axios.post(url, data)
          .then( () => {
            this.$router.push({ name: 'manage-killerq-templates' });
          })
          .catch();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .subtext {
    font-size: 0.8rem;
  }
</style>